// import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   Button,
//   CircularProgress,
//   Grid,
//   Snackbar,
//   IconButton,
// } from "@mui/material";
// import { motion, useAnimation } from "framer-motion";
// import {
//   Info,
//   People,
//   Edit,
//   Delete,
//   BarChart,
//   ErrorOutline,
//   Refresh,
// } from "@mui/icons-material";
// import axios from "axios";

// const calculateTimeRemaining = (endDate) => {
//   if (!endDate) return "N/A";
//   const now = new Date();
//   const end = new Date(endDate);
//   const diff = end - now;

//   if (diff <= 0) return "Expired";

//   const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//   const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//   const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//   const seconds = Math.floor((diff % (1000 * 60)) / 1000);

//   return `${days}d ${hours}h ${minutes}m ${seconds}s`;
// };

// const ScheduledExamDetails = () => {
//   const { state } = useLocation();
//   const { scheduledExam, schoolId } = state || {};
//   const navigate = useNavigate();

//   const [examDetails, setExamDetails] = useState(scheduledExam);
//   const [timeRemaining, setTimeRemaining] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [teacherSubmissions, setTeacherSubmissions] = useState([]);
//   const [error, setError] = useState(null);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [extensionMinutes, setExtensionMinutes] = useState(60);
//   const [extending, setExtending] = useState(false);

//   const controls = {
//     header: useAnimation(),
//     card: useAnimation(),
//   };

//   const cardScale = useRef(0.9);

//   useEffect(() => {
//     const animate = async () => {
//       await Promise.all([
//         controls.header.start({
//           opacity: 1,
//           y: 0,
//           transition: { duration: 0.8 },
//         }),
//         controls.card.start({
//           opacity: 1,
//           scale: 1,
//           transition: { type: "spring", stiffness: 100, delay: 0.3 },
//         }),
//       ]);
//     };
//     animate();

//     const interval = setInterval(() => {
//       setTimeRemaining(calculateTimeRemaining(examDetails?.endDate));
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [examDetails?.endDate, controls]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const submissionsResponse = await axios
//           .get(
//             `https://kidsm.vercel.app/api/schools/scheduled-exams/submitted-results`,
//             { params: { scheduledExamId: scheduledExam._id } }
//           )
//           .catch((err) => {
//             console.error(
//               "Error fetching teacher submissions:",
//               err.message,
//               err.response?.status,
//               err.response?.data
//             );
//             if (err.response?.status === 404) {
//               setError("Teacher submissions data is not available.");
//             }
//             return { data: { submittedResults: [] } };
//           });

//         setTeacherSubmissions(submissionsResponse.data.submittedResults || []);
//       } catch (error) {
//         console.error("Error fetching data:", error.message);
//         setError("Failed to load exam details. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [scheduledExam?._id]);

//   const handleCardPress = async (path, params = {}) => {
//     await controls.card.start({ scale: 0.95, transition: { duration: 0.1 } });
//     await controls.card.start({
//       scale: 1,
//       transition: { type: "spring", stiffness: 200 },
//     });
//     navigate(path, { state: params });
//   };

//   const handleEditExam = () => {
//     navigate("/schedule-exam", { state: { schoolId, exam: examDetails } });
//   };

//   const handleExtendExam = async () => {
//     if (!extensionMinutes || extensionMinutes <= 0) {
//       setSnackbar({
//         open: true,
//         message: "Please enter a valid extension time",
//         severity: "error",
//       });
//       return;
//     }

//     setExtending(true);
//     try {
//       const response = await axios.put(
//         `https://kidsm.vercel.app/api/schools/scheduled-exams/${examDetails._id}/extend`,
//         {
//           schoolId,
//           extensionMinutes: parseInt(extensionMinutes),
//         }
//       );

//       if (response.data.success) {
//         setExamDetails(response.data.exam);
//         setSnackbar({
//           open: true,
//           message: `Exam extended by ${extensionMinutes} minutes successfully!`,
//           severity: "success",
//         });
//         setExtensionMinutes(60); // Reset to default
//       }
//     } catch (error) {
//       console.error("Error extending exam:", error);
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || "Failed to extend exam",
//         severity: "error",
//       });
//     } finally {
//       setExtending(false);
//     }
//   };

//   const handleDeleteExam = async () => {
//     if (!window.confirm("Are you sure you want to delete this scheduled exam?"))
//       return;
//     setLoading(true);
//     try {
//       const response = await axios.delete(
//         `https://kidsm.vercel.app/api/schools/scheduled-exams/${examDetails._id}`
//       );
//       if (response.data.success) {
//         setSnackbar({
//           open: true,
//           message: "Exam deleted successfully!",
//           severity: "success",
//         });
//         setTimeout(() => navigate(-1), 2000);
//       } else {
//         setSnackbar({
//           open: true,
//           message: response.data.message || "Failed to delete exam",
//           severity: "error",
//         });
//       }
//     } catch (error) {
//       console.error("Error deleting exam:", error);
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || "Failed to delete exam",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRetry = () => {
//     setError(null);
//     setLoading(true);
//     // Re-fetch data
//     const fetchData = async () => {
//       try {
//         const submissionsResponse = await axios.get(
//           `https://kidsm.vercel.app/api/schools/scheduled-exams/submitted-results`,
//           { params: { scheduledExamId: scheduledExam._id } }
//         );
//         setTeacherSubmissions(submissionsResponse.data.submittedResults || []);
//       } catch (error) {
//         setError("Failed to load exam details. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   };

//   if (!scheduledExam) {
//     return (
//       <Container
//         maxWidth="md"
//         sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
//       >
//         <Typography variant="h6" sx={{ textAlign: "center", color: "#2c3e50" }}>
//           Error: No exam data available
//         </Typography>
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container
//         maxWidth="md"
//         sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             minHeight: "100vh",
//           }}
//         >
//           <ErrorOutline sx={{ fontSize: 40, color: "#e74c3c", mb: 2 }} />
//           <Typography
//             sx={{
//               fontSize: "1.125rem",
//               color: "#e74c3c",
//               textAlign: "center",
//               mb: 2,
//             }}
//           >
//             {error}
//           </Typography>
//           <Button
//             variant="contained"
//             startIcon={<Refresh />}
//             sx={{
//               bgcolor: "#6200ee",
//               borderRadius: 2,
//               px: 3,
//               py: 1,
//               textTransform: "none",
//             }}
//             onClick={handleRetry}
//           >
//             Retry
//           </Button>
//         </Box>
//       </Container>
//     );
//   }

//   if (loading) {
//     return (
//       <Container
//         maxWidth="md"
//         sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             minHeight: "100vh",
//           }}
//         >
//           <CircularProgress color="primary" />
//           <Typography sx={{ mt: 2, fontSize: "1rem", color: "#6200ee" }}>
//             Loading exam details...
//           </Typography>
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container
//       maxWidth="md"
//       sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
//     >
//       <motion.div initial={{ opacity: 0, y: 30 }} animate={controls.header}>
//         <Box
//           sx={{
//             p: 3,
//             bgcolor: "#fff",
//             borderBottom: "1px solid #e0e0e0",
//             mb: 2,
//           }}
//         >
//           <Typography
//             variant="h4"
//             sx={{ fontWeight: "bold", color: "#2c3e50" }}
//           >
//             {examDetails?.examType || "Exam"}
//             {examDetails?.examName ? `: ${examDetails.examName}` : ""} (
//             {examDetails?.term || "N/A"})
//           </Typography>
//           <Typography sx={{ fontSize: "1rem", color: "#7f8c8d", mt: 1 }}>
//             Exam Details
//           </Typography>
//         </Box>
//       </motion.div>

//       <Box sx={{ px: 2 }}>
//         <motion.div
//           initial={{ opacity: 0, scale: cardScale.current }}
//           animate={controls.card}
//         >
//           <Box sx={{ mb: 4 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <Info sx={{ color: "#6200ee", fontSize: 24, mr: 1 }} />
//               <Typography
//                 variant="h5"
//                 sx={{ fontWeight: "bold", color: "#2c3e50" }}
//               >
//                 Overview
//               </Typography>
//             </Box>
//             <Card
//               sx={{
//                 bgcolor: "#fff",
//                 borderRadius: 3,
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                 mb: 2,
//                 p: 2,
//               }}
//             >
//               <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
//                 <strong>Start Date: </strong>
//                 {examDetails?.startDate
//                   ? new Date(examDetails.startDate).toLocaleDateString()
//                   : "N/A"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
//                 <strong>End Date: </strong>
//                 {examDetails?.endDate
//                   ? new Date(examDetails.endDate).toLocaleDateString()
//                   : "N/A"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
//                 <strong>Time Remaining: </strong>
//                 {timeRemaining || "N/A"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
//                 <strong>Subjects: </strong>
//                 {examDetails?.subjects?.join(", ") || "N/A"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
//                 <strong>Classes: </strong>
//                 {examDetails?.classes?.join(", ") || "N/A"}
//               </Typography>
//             </Card>
//           </Box>

//           <Box sx={{ mb: 4 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <People sx={{ color: "#6200ee", fontSize: 24, mr: 1 }} />
//               <Typography
//                 variant="h5"
//                 sx={{ fontWeight: "bold", color: "#2c3e50" }}
//               >
//                 Teacher Submissions
//               </Typography>
//             </Box>
//             {teacherSubmissions.length === 0 ? (
//               <Card
//                 sx={{
//                   bgcolor: "#fff",
//                   borderRadius: 3,
//                   boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                   p: 2,
//                 }}
//               >
//                 <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
//                   No submissions recorded yet.
//                 </Typography>
//               </Card>
//             ) : (
//               teacherSubmissions.map((submission, index) => (
//                 <Card
//                   key={index}
//                   sx={{
//                     bgcolor: "#fff",
//                     borderRadius: 3,
//                     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                     mb: 2,
//                     p: 2,
//                   }}
//                 >
//                   <Typography
//                     sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}
//                   >
//                     <strong>Teacher: </strong>
//                     {submission.teacherName || "Unknown"}
//                   </Typography>
//                   <Typography
//                     sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}
//                   >
//                     <strong>Class: </strong>
//                     {submission.class}
//                     {submission.stream ? ` (${submission.stream})` : ""}
//                   </Typography>
//                   <Typography
//                     sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}
//                   >
//                     <strong>Subject: </strong>
//                     {submission.subject || "N/A"}
//                   </Typography>
//                   <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
//                     <strong>Submitted: </strong>
//                     {submission.submissionDate
//                       ? new Date(submission.submissionDate).toLocaleString()
//                       : "N/A"}
//                   </Typography>
//                 </Card>
//               ))
//             )}
//           </Box>

//           <Box>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <Edit sx={{ color: "#6200ee", fontSize: 24, mr: 1 }} />
//               <Typography
//                 variant="h5"
//                 sx={{ fontWeight: "bold", color: "#2c3e50" }}
//               >
//                 Actions
//               </Typography>
//             </Box>
//             <Card
//               sx={{
//                 bgcolor: "#fff",
//                 borderRadius: 3,
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                 mb: 2,
//                 cursor: "pointer",
//               }}
//               onClick={() =>
//                 handleCardPress("/modify-class-results", {
//                   schoolId,
//                   examId: scheduledExam._id,
//                 })
//               }
//             >
//               <CardContent
//                 sx={{ display: "flex", flexDirection: "column", p: 2 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                   <Edit sx={{ color: "#6200ee", fontSize: 20, mr: 1 }} />
//                   <Typography
//                     sx={{
//                       fontSize: "1.125rem",
//                       fontWeight: 600,
//                       color: "#2c3e50",
//                     }}
//                   >
//                     Modify Results
//                   </Typography>
//                 </Box>
//                 <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
//                   Edit or update student results for this exam
//                 </Typography>
//               </CardContent>
//             </Card>
//             <Card
//               sx={{
//                 bgcolor: "#fff",
//                 borderRadius: 3,
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                 mb: 2,
//                 cursor: "pointer",
//               }}
//               onClick={() =>
//                 handleCardPress("/school-performance", {
//                   schoolId,
//                   examId: scheduledExam._id,
//                 })
//               }
//             >
//               <CardContent
//                 sx={{ display: "flex", flexDirection: "column", p: 2 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                   <BarChart sx={{ color: "#6200ee", fontSize: 20, mr: 1 }} />
//                   <Typography
//                     sx={{
//                       fontSize: "1.125rem",
//                       fontWeight: 600,
//                       color: "#2c3e50",
//                     }}
//                   >
//                     View Performance
//                   </Typography>
//                 </Box>
//                 <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
//                   Analyze detailed performance metrics
//                 </Typography>
//               </CardContent>
//             </Card>
//             <Card
//               sx={{
//                 bgcolor: "#4CAF50",
//                 borderRadius: 3,
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                 mb: 2,
//                 cursor: "pointer",
//               }}
//               onClick={handleEditExam}
//             >
//               <CardContent
//                 sx={{ display: "flex", flexDirection: "column", p: 2 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                   <Edit sx={{ color: "#fff", fontSize: 20, mr: 1 }} />
//                   <Typography
//                     sx={{
//                       fontSize: "1.125rem",
//                       fontWeight: 600,
//                       color: "#fff",
//                     }}
//                   >
//                     Edit Exam
//                   </Typography>
//                 </Box>
//                 <Typography sx={{ fontSize: "0.875rem", color: "#fff" }}>
//                   Modify exam details
//                 </Typography>
//               </CardContent>
//             </Card>
//             <Card
//               sx={{
//                 bgcolor: "#e74c3c",
//                 borderRadius: 3,
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                 cursor: "pointer",
//               }}
//               onClick={handleDeleteExam}
//             >
//               <CardContent
//                 sx={{ display: "flex", flexDirection: "column", p: 2 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//                   <Delete sx={{ color: "#fff", fontSize: 20, mr: 1 }} />
//                   <Typography
//                     sx={{
//                       fontSize: "1.125rem",
//                       fontWeight: 600,
//                       color: "#fff",
//                     }}
//                   >
//                     Delete Exam
//                   </Typography>
//                 </Box>
//                 <Typography sx={{ fontSize: "0.875rem", color: "#fff" }}>
//                   Remove this exam
//                 </Typography>
//               </CardContent>
//             </Card>
//           </Box>
//         </motion.div>
//       </Box>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         message={snackbar.message}
//         sx={{
//           bgcolor: snackbar.severity === "success" ? "#4CAF50" : "#e74c3c",
//         }}
//       />
//     </Container>
//   );
// };

// export default ScheduledExamDetails;

import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Grid,
  Snackbar,
  IconButton,
  TextField,
} from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import {
  Info,
  People,
  Edit,
  Delete,
  BarChart,
  ErrorOutline,
  Refresh,
  AccessTime,
} from "@mui/icons-material";
import axios from "axios";

const calculateTimeRemaining = (endDate) => {
  if (!endDate) return "N/A";
  const now = new Date();
  const end = new Date(endDate);
  const diff = end - now;

  if (diff <= 0) return "Expired";

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
};

const ScheduledExamDetails = () => {
  const { state } = useLocation();
  const { scheduledExam, schoolId } = state || {};
  const navigate = useNavigate();

  const [examDetails, setExamDetails] = useState(scheduledExam);
  const [timeRemaining, setTimeRemaining] = useState("");
  const [loading, setLoading] = useState(true);
  const [teacherSubmissions, setTeacherSubmissions] = useState([]);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // New state for extension functionality
  const [extensionMinutes, setExtensionMinutes] = useState(60);
  const [extending, setExtending] = useState(false);

  const controls = {
    header: useAnimation(),
    card: useAnimation(),
  };

  const cardScale = useRef(0.9);

  useEffect(() => {
    const animate = async () => {
      await Promise.all([
        controls.header.start({
          opacity: 1,
          y: 0,
          transition: { duration: 0.8 },
        }),
        controls.card.start({
          opacity: 1,
          scale: 1,
          transition: { type: "spring", stiffness: 100, delay: 0.3 },
        }),
      ]);
    };
    animate();

    const interval = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining(examDetails?.endDate));
    }, 1000);

    return () => clearInterval(interval);
  }, [examDetails?.endDate, controls]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const submissionsResponse = await axios
          .get(
            `https://kidsm.vercel.app/api/schools/scheduled-exams/submitted-results`,
            { params: { scheduledExamId: scheduledExam._id } }
          )
          .catch((err) => {
            console.error(
              "Error fetching teacher submissions:",
              err.message,
              err.response?.status,
              err.response?.data
            );
            if (err.response?.status === 404) {
              setError("Teacher submissions data is not available.");
            }
            return { data: { submittedResults: [] } };
          });

        setTeacherSubmissions(submissionsResponse.data.submittedResults || []);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setError("Failed to load exam details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [scheduledExam?._id]);

  const handleCardPress = async (path, params = {}) => {
    await controls.card.start({ scale: 0.95, transition: { duration: 0.1 } });
    await controls.card.start({
      scale: 1,
      transition: { type: "spring", stiffness: 200 },
    });
    navigate(path, { state: params });
  };

  const handleEditExam = () => {
    navigate("/schedule-exam", { state: { schoolId, exam: examDetails } });
  };

  const handleDeleteExam = async () => {
    if (!window.confirm("Are you sure you want to delete this scheduled exam?"))
      return;
    setLoading(true);
    try {
      const response = await axios.delete(
        `https://kidsm.vercel.app/api/schools/scheduled-exams/${examDetails._id}`
      );
      if (response.data.success) {
        setSnackbar({
          open: true,
          message: "Exam deleted successfully!",
          severity: "success",
        });
        setTimeout(() => navigate(-1), 2000);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || "Failed to delete exam",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error deleting exam:", error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to delete exam",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // New function to handle exam extension
  const handleExtendExam = async () => {
    if (!extensionMinutes || extensionMinutes <= 0) {
      setSnackbar({
        open: true,
        message: "Please enter a valid extension time",
        severity: "error",
      });
      return;
    }

    setExtending(true);
    try {
      const response = await axios.put(
        `https://kidsm.vercel.app/api/schools/scheduled-exams/${examDetails._id}/extend`,
        {
          schoolId,
          extensionMinutes: parseInt(extensionMinutes),
        }
      );

      if (response.data.success) {
        setExamDetails(response.data.exam);
        setSnackbar({
          open: true,
          message: `Exam extended by ${extensionMinutes} minutes successfully!`,
          severity: "success",
        });
        setExtensionMinutes(60); // Reset to default
      }
    } catch (error) {
      console.error("Error extending exam:", error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Failed to extend exam",
        severity: "error",
      });
    } finally {
      setExtending(false);
    }
  };

  const handleRetry = () => {
    setError(null);
    setLoading(true);
    // Re-fetch data
    const fetchData = async () => {
      try {
        const submissionsResponse = await axios.get(
          `https://kidsm.vercel.app/api/schools/scheduled-exams/submitted-results`,
          { params: { scheduledExamId: scheduledExam._id } }
        );
        setTeacherSubmissions(submissionsResponse.data.submittedResults || []);
      } catch (error) {
        setError("Failed to load exam details. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  };

  if (!scheduledExam) {
    return (
      <Container
        maxWidth="md"
        sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
      >
        <Typography variant="h6" sx={{ textAlign: "center", color: "#2c3e50" }}>
          Error: No exam data available
        </Typography>
      </Container>
    );
  }

  if (error) {
    return (
      <Container
        maxWidth="md"
        sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <ErrorOutline sx={{ fontSize: 40, color: "#e74c3c", mb: 2 }} />
          <Typography
            sx={{
              fontSize: "1.125rem",
              color: "#e74c3c",
              textAlign: "center",
              mb: 2,
            }}
          >
            {error}
          </Typography>
          <Button
            variant="contained"
            startIcon={<Refresh />}
            sx={{
              bgcolor: "#6200ee",
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: "none",
            }}
            onClick={handleRetry}
          >
            Retry
          </Button>
        </Box>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container
        maxWidth="md"
        sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <CircularProgress color="primary" />
          <Typography sx={{ mt: 2, fontSize: "1rem", color: "#6200ee" }}>
            Loading exam details...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container
      maxWidth="md"
      sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
    >
      <motion.div initial={{ opacity: 0, y: 30 }} animate={controls.header}>
        <Box
          sx={{
            p: 3,
            bgcolor: "#fff",
            borderBottom: "1px solid #e0e0e0",
            mb: 2,
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "#2c3e50" }}
          >
            {examDetails?.examType || "Exam"}
            {examDetails?.examName ? `: ${examDetails.examName}` : ""} (
            {examDetails?.term || "N/A"})
          </Typography>
          <Typography sx={{ fontSize: "1rem", color: "#7f8c8d", mt: 1 }}>
            Exam Details
          </Typography>
        </Box>
      </motion.div>

      <Box sx={{ px: 2 }}>
        <motion.div
          initial={{ opacity: 0, scale: cardScale.current }}
          animate={controls.card}
        >
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Info sx={{ color: "#6200ee", fontSize: 24, mr: 1 }} />
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#2c3e50" }}
              >
                Overview
              </Typography>
            </Box>
            <Card
              sx={{
                bgcolor: "#fff",
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                mb: 2,
                p: 2,
              }}
            >
              <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
                <strong>Start Date: </strong>
                {examDetails?.startDate
                  ? new Date(examDetails.startDate).toLocaleString()
                  : "N/A"}
              </Typography>
              <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
                <strong>End Date: </strong>
                {examDetails?.endDate
                  ? new Date(examDetails.endDate).toLocaleString()
                  : "N/A"}
              </Typography>
              <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
                <strong>Time Remaining: </strong>
                <span
                  style={{
                    color:
                      timeRemaining === "Expired"
                        ? "#e74c3c"
                        : timeRemaining.includes("0d")
                        ? "#f39c12"
                        : "#27ae60",
                    fontWeight: "bold",
                  }}
                >
                  {timeRemaining || "N/A"}
                </span>
              </Typography>
              <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
                <strong>Subjects: </strong>
                {examDetails?.subjects?.join(", ") || "N/A"}
              </Typography>
              <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
                <strong>Classes: </strong>
                {examDetails?.classes?.join(", ") || "N/A"}
              </Typography>
            </Card>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <People sx={{ color: "#6200ee", fontSize: 24, mr: 1 }} />
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#2c3e50" }}
              >
                Teacher Submissions
              </Typography>
            </Box>
            {teacherSubmissions.length === 0 ? (
              <Card
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 3,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  p: 2,
                }}
              >
                <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
                  No submissions recorded yet.
                </Typography>
              </Card>
            ) : (
              teacherSubmissions.map((submission, index) => (
                <Card
                  key={index}
                  sx={{
                    bgcolor: "#fff",
                    borderRadius: 3,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    mb: 2,
                    p: 2,
                  }}
                >
                  <Typography
                    sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}
                  >
                    <strong>Teacher: </strong>
                    {submission.teacherName || "Unknown"}
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}
                  >
                    <strong>Class: </strong>
                    {submission.class}
                    {submission.stream ? ` (${submission.stream})` : ""}
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}
                  >
                    <strong>Subject: </strong>
                    {submission.subject || "N/A"}
                  </Typography>
                  <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
                    <strong>Submitted: </strong>
                    {submission.submissionDate
                      ? new Date(submission.submissionDate).toLocaleString()
                      : "N/A"}
                  </Typography>
                </Card>
              ))
            )}
          </Box>

          <Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Edit sx={{ color: "#6200ee", fontSize: 24, mr: 1 }} />
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#2c3e50" }}
              >
                Actions
              </Typography>
            </Box>

            {/* Extend Exam Time Card */}
            <Card
              sx={{
                bgcolor: "#FF9800",
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                mb: 2,
                p: 2,
              }}
            >
              <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <AccessTime sx={{ color: "#fff", fontSize: 20, mr: 1 }} />
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      fontWeight: 600,
                      color: "#fff",
                    }}
                  >
                    Extend Exam Time
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                  <TextField
                    size="small"
                    type="number"
                    value={extensionMinutes}
                    onChange={(e) => setExtensionMinutes(e.target.value)}
                    label="Minutes"
                    sx={{
                      bgcolor: "#fff",
                      borderRadius: 1,
                      flex: 1,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "transparent",
                        },
                        "&:hover fieldset": {
                          borderColor: "#fff",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#fff",
                        },
                      },
                    }}
                    inputProps={{ min: 1 }}
                  />
                  <Button
                    variant="contained"
                    onClick={handleExtendExam}
                    disabled={extending}
                    sx={{
                      bgcolor: "#fff",
                      color: "#FF9800",
                      "&:hover": {
                        bgcolor: "#f5f5f5",
                      },
                      minWidth: "80px",
                    }}
                  >
                    {extending ? <CircularProgress size={20} /> : "Extend"}
                  </Button>
                </Box>
                <Typography sx={{ fontSize: "0.875rem", color: "#fff" }}>
                  Add extra time for teachers to submit results
                </Typography>
              </CardContent>
            </Card>

            <Card
              sx={{
                bgcolor: "#fff",
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                mb: 2,
                cursor: "pointer",
              }}
              onClick={() =>
                handleCardPress("/modify-class-results", {
                  schoolId,
                  examId: scheduledExam._id,
                })
              }
            >
              <CardContent
                sx={{ display: "flex", flexDirection: "column", p: 2 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <Edit sx={{ color: "#6200ee", fontSize: 20, mr: 1 }} />
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      fontWeight: 600,
                      color: "#2c3e50",
                    }}
                  >
                    Modify Results
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
                  Edit or update student results for this exam
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                bgcolor: "#fff",
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                mb: 2,
                cursor: "pointer",
              }}
              onClick={() =>
                handleCardPress("/school-performance", {
                  schoolId,
                  examId: scheduledExam._id,
                })
              }
            >
              <CardContent
                sx={{ display: "flex", flexDirection: "column", p: 2 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <BarChart sx={{ color: "#6200ee", fontSize: 20, mr: 1 }} />
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      fontWeight: 600,
                      color: "#2c3e50",
                    }}
                  >
                    View Performance
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
                  Analyze detailed performance metrics
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                bgcolor: "#4CAF50",
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                mb: 2,
                cursor: "pointer",
              }}
              onClick={handleEditExam}
            >
              <CardContent
                sx={{ display: "flex", flexDirection: "column", p: 2 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <Edit sx={{ color: "#fff", fontSize: 20, mr: 1 }} />
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      fontWeight: 600,
                      color: "#fff",
                    }}
                  >
                    Edit Exam
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "0.875rem", color: "#fff" }}>
                  Modify exam details
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                bgcolor: "#e74c3c",
                borderRadius: 3,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                cursor: "pointer",
              }}
              onClick={handleDeleteExam}
            >
              <CardContent
                sx={{ display: "flex", flexDirection: "column", p: 2 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <Delete sx={{ color: "#fff", fontSize: 20, mr: 1 }} />
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      fontWeight: 600,
                      color: "#fff",
                    }}
                  >
                    Delete Exam
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "0.875rem", color: "#fff" }}>
                  Remove this exam
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </motion.div>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        sx={{
          bgcolor: snackbar.severity === "success" ? "#4CAF50" : "#e74c3c",
        }}
      />
    </Container>
  );
};

export default ScheduledExamDetails;
